// extracted by mini-css-extract-plugin
module.exports = {"container":"raceTime_container__71_CK","soon":"raceTime_soon__KwYub"};